module.exports = __webpack_public_path__ + "images/knac_small028f94376ddecaeb06c6023a0fabf8bf.png";